import api from "../apis/selectree_api";
import { getAuthHeader } from "../utilities/header";

export const getAllGlossaryTerms = async () => {
  try {
    const response = await api.get("tree/glossary", getAuthHeader());
    return response.data;
  } catch (error) {
    console.error("Error fetching glossary terms:", error);
    throw error;
  }
};

export const createGlossaryTerm = async createData => {
  try {
    const response = await api.post(
      "tree/glossary",
      createData,
      getAuthHeader()
    );
    return response.data;
  } catch (error) {
    console.error(`Error creating glossary term: ${error}`);
    throw error;
  }
};

export const editGlossaryTerm = async (id, updateData) => {
  try {
    const response = await api.put(
      `tree/glossary/${id}`,
      updateData,
      getAuthHeader()
    );
    return response.data;
  } catch (error) {
    console.error(`Error editing glossary term: ${error}`);
    throw error;
  }
};

export const deleteGlossaryTerm = async id => {
  try {
    const response = await api.delete(`tree/glossary/${id}`, getAuthHeader());
    return response.data;
  } catch (error) {
    console.error(`Error deleting glossary term: ${error}`);
    throw error;
  }
};

export const uploadGlossaryPhoto = async (glossaryId, photoFile) => {
  try {
    const formData = new FormData();
    formData.append("photo", photoFile);

    const response = await api.post(
      `tree/glossary/${glossaryId}/photo`,
      formData,
      {
        ...getAuthHeader(),
        headers: {
          ...getAuthHeader().headers,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(`Error uploading glossary photo: ${error}`);
    throw error;
  }
};

export const deleteGlossaryPhoto = async photoId => {
  try {
    const response = await api.delete(
      `tree/glossary/photo/${photoId}`,
      getAuthHeader()
    );
    return response.data;
  } catch (error) {
    console.error(`Error deleting glossary photo: ${error}`);
    throw error;
  }
};

export const updateGlossaryPhotoText = async (
  glossaryPhotoId,
  definitionText
) => {
  try {
    const payload = { definition_text: definitionText };
    const response = await api.put(
      `tree/glossary_photos/${glossaryPhotoId}/definition`,
      payload,
      getAuthHeader()
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating glossary photo definition text: ${error}`);
    throw error;
  }
};
